export default __webpack_public_path__ + "static/media/logoMobile.a75b32af.png";